var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrescriptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#FBA622",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.875 54.375H86.25V52.5C86.247 51.5064 85.851 50.5542 85.1484 49.8516C84.4458 49.149 83.4936 48.753 82.5 48.75H67.5C66.5064 48.753 65.5542 49.149 64.8516 49.8516C64.149 50.5542 63.753 51.5064 63.75 52.5V54.375H58.125C57.1314 54.378 56.1792 54.774 55.4766 55.4766C54.774 56.1792 54.378 57.1314 54.375 58.125V97.5C54.378 98.4936 54.774 99.4458 55.4766 100.148C56.1792 100.851 57.1314 101.247 58.125 101.25H75V97.5H58.125V58.125H63.75V63.75H86.25V58.125H91.875V78.75H95.625V58.125C95.622 57.1314 95.226 56.1792 94.5234 55.4766C93.8208 54.774 92.8686 54.378 91.875 54.375ZM82.5 60H67.5V52.5H82.5V60Z",
    fill: "#136773"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99 86.9962L96.025 84L85.1238 94.9862L80.725 90.5663L77.75 93.5625L85.1238 101L99 86.9962Z",
    fill: "#FBA622"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionIcon);
export default __webpack_public_path__ + "static/media/prescriptionIcon.775b03993cd6af06f75e2142fc27c094.svg";
export { ForwardRef as ReactComponent };